import { Component, Input } from '@angular/core';
import { Job } from '../../class/job.class';
import { NgClass, NgStyle } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-horizontal-stepper',
  imports: [NgClass, NgStyle, TranslateModule],
  templateUrl: './horizontal-stepper.component.html',
  styleUrl: './horizontal-stepper.component.scss',
})
export class HorizontalStepperComponent {
  @Input() job: Job | undefined;
}
